module.exports = __webpack_public_path__ + "img/partner_img4.ec56357a.png";